"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineComponent = exports.transpileDefaultProps = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/* ++++++++++ --------------- DEFINE COMPONENT --------------- ++++++++++ */
// used for our interactive demo showcase
// formats a defaultProps object from <compName>_definition files


var transpileDefaultProps = function transpileDefaultProps(definition) {
  var defaultProps = {};
  Object.entries(definition.props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propName = _ref2[0],
        propDetails = _ref2[1];

    if (propDetails['default'] !== null && propDetails['default']) Object.defineProperty(defaultProps, propName, {
      value: propDetails['default'],
      writable: true,
      enumerable: true
    });
  });
  return defaultProps;
}; // takes in a definition object (from <compName>_definition file) and appends to component
// takes in a withDefaults prop that tells the function whether or not to define defaultProps on the component


exports.transpileDefaultProps = transpileDefaultProps;

var defineComponent = function defineComponent(component, definition) {
  var withDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  definition.defaults = transpileDefaultProps(definition);
  component.definition = definition; // component.defaultProps = { definition: definition }; // for access from inside the component itself (for example, inside cta.js you would be able to access definition via props)

  if (withDefaults) component.defaultProps = Object.assign({}, component.defaultProps, transpileDefaultProps(definition));
};

exports.defineComponent = defineComponent;